import { colors } from '../stylesheets';

const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

const statusColor = (status) => {
  if (status === 'success') {
    return 'green';
  } else if (status === 'failure') {
    return 'red';
  } else if (status === 'info') {
    return 'blue';
  } else {
    return 'yellow';
  }
};

const getStatusColor = (status) => colors[statusColor(status)];

export { hex2rgba, statusColor, getStatusColor };
